import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

function VirtualDigestMenu(): JSX.Element {
  return (
    <ul className="nav navbar-nav form-inline">
      <li className="ladder-options">
        <label>Ladder</label>
        <select className="select-medium" />
      </li>
      <li>
        <Button
          buttonStyle={ButtonStyle.TERTIARY_GRAY}
          size={ButtonSize.MINI}
          className="download-btn"
          text="Download PNG"
        />
      </li>
    </ul>
  );
}

export default makeDeprecatedJadeStyleTemplate(VirtualDigestMenu);
